module.exports = __webpack_public_path__ + "static/media/close-drawer.b3ac9ad5.svg";